import React, { useEffect, useRef, useState } from "react";
import { SET_GAME_BONUS_RESULT_POST } from "../../api/ApiConst";
import { callPostApi } from "../../api/ApiCaller";

function RouletteBonus({keyboardInput, gameSessionRecordId, onBonusRoundCompleted, gameResult }) {
    const [isSpinning, setIsSpinning] = useState(false);
    const [wheelResult, setWheelResult] = useState(0);
    const [rotation, setRotation] = useState(0);
    const [resultNumber, setResultNumber] = useState(null);
    const wheelRef = useRef(null);

    const startSoundRef = useRef(null);
    const endSoundRef = useRef(null);


    useEffect(() => {
        // Infinite rotation on page load
        const interval = setInterval(() => {
            if (!isSpinning) {
                setRotation((prev) => prev - 15);
            }
        }, 20);

        return () => clearInterval(interval);
    }, [isSpinning]);



    useEffect(() => {
        const handleKeyPress = (event) => {
            const key = event.key.toLowerCase();
            if (key === "b") {
                handleBoxClick();
            }
        };

        if (keyboardInput) {
            window.addEventListener("keydown", handleKeyPress);
            return () => {
                window.removeEventListener("keydown", handleKeyPress);
            };
        }


    }, [keyboardInput, gameSessionRecordId]);

    const handleSoundRoulette = () => {
        let winningDiv = document.getElementById("bonus2-winning-value");
        const startSound = startSoundRef.current;
        const endSound = endSoundRef.current;

        if (startSound) {
            let startSoundCount = 0;

            // setShowValue(true);
            const startSoundInterval = setInterval(() => {
                if (startSoundCount < 2) {
                    winningDiv.classList.add('d-none');
                    setTimeout(() => {
                        if (winningDiv.classList.contains('d-none')) {
                            winningDiv.classList.remove('d-none');
                        }
                    }, 200);
                    // setShowValue(prev => !prev);
                    startSound.play();
                    startSoundCount++;
                } else {
                    clearInterval(startSoundInterval);
                    startSound.pause();
                    startSound.currentTime = 0;
                }
            }, 1000);
        }
        if (endSound) {
            setTimeout(() => {
                let endSoundCount = 0;

                const endSoundInterval = setInterval(() => {
                    if (endSoundCount < 2) {
                        endSound.play();
                        endSoundCount++;
                    } else {
                        clearInterval(endSoundInterval);
                        endSound.pause();
                        endSound.currentTime = 0;
                    }
                }, 1000);
            }, 2000);
        }
    }

    const rotationStyle = {
        transform: `rotate(${rotation}deg)`,
        transition: isSpinning ? "transform 1s ease-out" : "transform 0.01s linear",
        width: "100%",
        height: "100%",
        position: "relative",
    };

    const handleBoxClick = () => {

        if (isSpinning) return;

        setIsSpinning(true);
        let winningNumber;

        const totalPoints = 24;
        const pointAngle = 360 / totalPoints;

        const finalRotation = rotation % 360 - 15;
        const winningIndex = Math.floor((360 - finalRotation) / pointAngle) % totalPoints;
        winningNumber = winningIndex === 0 ? totalPoints : winningIndex;

        setResultNumber(winningNumber);

        const payload = {
            bonusType: "Bonus02Roulette",
            recordId: gameSessionRecordId,
            tileNumber: winningNumber
        };

        callPostApi(SET_GAME_BONUS_RESULT_POST, payload, {}, (response) => {
            let res = response?.responsePacket;
            if (response?.errorCode === 0) {
                let gameTotalWin = gameResult.winnings * winningNumber;
                setWheelResult(gameTotalWin);

                // sound code
                handleSoundRoulette()

                // show winning code
                if (gameTotalWin >= 0) {
                    setTimeout(() => {
                        if (onBonusRoundCompleted) {
                            onBonusRoundCompleted(gameTotalWin);
                        }
                    }, 6000);
                }
            } else {
                console.error("API Call Failed:", response?.errorMessage || "Unknown error");
            }
        });
    };

    const loadStaticAudio = () => {
        return (
            <>
                <div style={{ display: "none" }}>
                    <audio controls="" ref={endSoundRef} id="plopEndSound" className="audioFile">
                        <source src="assets/plop.wav" type="audio/mpeg" />
                    </audio>
                    <audio controls="" ref={startSoundRef} id="stakeStartSound" className="audioFile">
                        <source src="assets/stake.mp3" type="audio/mpeg" />
                    </audio>
                </div>
            </>
        );
    };

    return (
        <>
            <div className="h-100 w-100 position-relative">
                <img className="h-100 w-100" src="assets/img/Roulette/bg.png" alt="" />
                <div className="contentPosition p-0">
                    <div className="cauldron-content bg-transparent ">
                        <div className="cauldron-inner-content">
                            <div className="text-center position-relative">
                                <img className="w-100" src="./assets/img/Roulette/header-bar.png" alt="" />
                                <div className="header-content">
                                    <div className="header-text">Multiplicador</div>
                                    <div className="Arrow-div">
                                        <img className="w-100" src="./assets/img/Roulette/seta.png" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="bg-black h-100 ">
                                <div className=" container-fluid h-100 position-relative">
                                    <h2 className="text-white vw-2-5 position-absolute top-0 start-0 ps-3">Clique para Jogar</h2>
                                    <div className="wheel-row">
                                        <div
                                            className="wheel-box position-relative "
                                            onClick={handleBoxClick}
                                            disabled={isSpinning}
                                        >
                                            <div className="wheel" >
                                                <img ref={wheelRef} style={rotationStyle} src="assets/img/Roulette/wheel.png" alt="Wheel" />
                                            </div>
                                        </div>
                                        <div className="wheel-btn-content d-flex align-items-center justify-content-center">
                                            <div className="text-center w-50 ">
                                                <h3 className="vw-3 text-yellow">
                                                    Wheel of
                                                    <br /> Fortune!
                                                </h3>
                                                <div className="btn-value mt-5 ">
                                                    <img className="w-100" src="./assets/img/Roulette/score-btn.png" alt="" />
                                                    <div id="bonus2-winning-value" className="text-content"> {isSpinning ? wheelResult : gameResult.winnings}</div>
                                                </div>
                                                <h3 className="vw-3 text-yellow mt-3 ">Premio</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loadStaticAudio()}
        </>
    );
}

export default RouletteBonus;
